module.exports = __webpack_public_path__ + "static/media/medium.9c5a7500.svg";